import { render, staticRenderFns } from "./Article1DesktopWithoutQRCode.vue?vue&type=template&id=37e47894&scoped=true&"
import script from "./Article1DesktopWithoutQRCode.vue?vue&type=script&lang=js&"
export * from "./Article1DesktopWithoutQRCode.vue?vue&type=script&lang=js&"
import style0 from "./Article1DesktopWithoutQRCode.vue?vue&type=style&index=0&id=37e47894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e47894",
  null
  
)

export default component.exports